export const GeographyLevel = {
  DIVISION: 1,
  REGION: 2,
  DISTRICT: 3
};
